export default __webpack_public_path__ + "static/media/HongVanPham_Resume.1d03a1f1.pdf";